<template>
    <div class="d-flex flex-1 h-100 overflow-hidden">
        <v-card class="report-container w-100  p-0" style="border-radius: 12px; margin-bottom: 24px">
			<v-toolbar class="shadow-none" style="flex: unset;" content-class="h-auto">
                <div class="custom-icon-wrapper">
                    <v-icon @click="backToAdminPage()">custom-icon left-arrow-icon</v-icon>
                </div>
                <v-toolbar-title class="size-16 dark-text">{{ $t("res_Title_ManageCustomLookups") }}</v-toolbar-title>
            </v-toolbar>

            <div class="border-top p-4 flex-1 overflow-auto text-end" style="max-height: 100px">
				<v-btn @click="showAddDialog" width="100px" color="primary">{{ $t("res_ButtonText_Add") }}</v-btn>
			</div>

			<div class="d-flex flex-1 flex-column overflow-auto" style="padding: 5px">
				<v-data-table :headers="headers" :items="items" :mobile-breakpoint="0" :items-per-page="items.length" disable-sort 
					:loading="loading" loading-text="loading..." caption="" calculate-widths header-fixed fixed-header hide-default-footer 
					class="position-relative white flex-1 d-flex overflow-auto">
					<template v-slot:item="row">
						<tr>
							<td>{{ row.item.name }}</td>
                            <td style="max-height: 50px !important;">
								{{ row.item.values }}
							</td>
							<td class="text-start">
								<div class="onhover-display">
									<div class="custom-icon-wrapper">
										<v-icon @click="editItem(row.item)">custom-icon white-bg edit-icon</v-icon>
									</div>
									<div class="custom-icon-wrapper">
										<v-icon @click="openDeleteDialog(row.item)">custom-icon white-bg delete-icon</v-icon>
									</div>
								</div>
							</td>
						</tr>
					</template>
				</v-data-table>
			</div>
		</v-card>

		<v-dialog v-model="addDialogVisible" content-class="fullscreen-dialog" fullscreen>
			<v-card>
                <v-toolbar class="bg-white">
                    <v-card-title class="p-0">{{ $t("res_Label_AddCustomLookup") }}</v-card-title>
                    <v-spacer></v-spacer>
                    <v-btn class="close-btn light-btn" icon dark @click="addDialogVisible = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <div class="d-flex flex-column overflow-auto h-100">
                   <div class="grid-12 flex-1 p-4 overflow-auto gap-2">
						<v-row>
							<v-col cols="12">
								<v-text-field solo v-model="editedItem.name" :label="$t('res_Label_Name')"></v-text-field>
							</v-col>
						</v-row>
						<br />
						<br />
						<br />
						<v-row>
							<v-col cols="3">
								<v-text-field solo v-model="jsonItem.Id" :label="$t('res_GridHeaders_Id')" :disabled="isEdit"></v-text-field>
							</v-col>
							<v-col cols="3">
								<v-text-field solo v-model="jsonItem.Name" :label="$t('res_Label_Name')"></v-text-field>
							</v-col>
							<v-col cols="3">
								<v-text-field solo v-model="jsonItem.NameAr" :label="$t('res_Label__NameAr')"></v-text-field>
							</v-col>
							<v-col cols="3">
                        		<v-btn color="primary" dense @click="addJsonItem" v-if="!isEdit">{{ $t("res_ButtonText_Add") }}</v-btn>
                        		<v-btn color="primary" dense @click="saveJsonItem" v-else>{{ $t("res_ButtonText_Edit") }}</v-btn>
							</v-col>
						</v-row>
						<v-row>
							<v-data-table hide-default-footer :headers="headers2" class="position-relative white flex-1 d-flex overflow-auto" :items="jsonItems"
								:items-per-page="jsonItems.length">
								<template v-slot:item="row">
									<tr>
										<td>{{ row.item.Id }}</td>
										<td>{{ row.item.Name }}</td>
										<td>{{ row.item.NameAr }}</td>
										<td class="text-start">
											<div class="onhover-display">
												<div class="custom-icon-wrapper">
													<v-icon @click="editJsonItem(row.item)">custom-icon white-bg edit-icon</v-icon>
												</div>
												<div class="custom-icon-wrapper">
													<v-icon @click="deleteJsonItem(row.item)">custom-icon white-bg delete-icon</v-icon>
												</div>
											</div>
										</td>
									</tr>
								</template>
							</v-data-table>
						</v-row>
					</div>
					<v-card-actions class="gap-2 sticky-actions">
						<v-spacer></v-spacer>
						<v-btn class="light-blue" style="min-width: 100px !important;" @click="cancelAddDialog()">{{ $t("res_ButtonText_Cancel") }}</v-btn>
						<v-btn class="primary" style="min-width: 100px !important;" @click="upsertItem()">{{ $t("res_ButtonText_Continue") }}</v-btn>
					</v-card-actions>
				</div>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import axios from "axios"
import constants from "@/assets/js/constants.js"
import router from '@/router/index.js'

export default {
	data() {
		return {
			loading: false,
			headers: [
				{ text: this.$t("res_GridHeaders_Name"), value: "name", align: "start", width: "10%" },
				{ text: this.$t("res_GridHeaders_Value"), value: "value", align: "start", width: "80%" },
				{ text: this.$t("res_GridHeaders_Actions"), value: "actions", align: "start", width: "10%" },
			],
			headers2: [
				{ text: this.$t("res_GridHeaders_Id"), value: "Id", align: "start", width: "10%", sortable: false },
				{ text: this.$t("res_GridHeaders_Name"), value: "Name", align: "start", width: "35%", sortable: false },
				{ text: this.$t("res_GridHeaders_NameAr"), value: "NameAr", align: "start", width: "35%", sortable: false },
				{ text: this.$t("res_GridHeaders_Actions"), value: "actions", align: "start", width: "10%", sortable: false },
			],
			items: [],
			jsonItems: [],
			isEdit: false,
			addDialogVisible: false,
			editedItem: { id: 0, name: "", values: "" },
			jsonItem: { Id: "", Name: "", NameAr: "" }
		};
	},
	methods: {
        backToAdminPage()
		{
            router.push({ name: 'manageSystemLookups' });
        },
		async fetchData() 
		{
			await axios.get(constants.baseApiUrl + "Lookups/GetCustomLookup")
				.then((res) => this.items = res.data)
				.catch((error) => console.error("Error fetching data:", error));
		},
		showAddDialog() 
		{
			this.addDialogVisible = true
			this.jsonItems = []
			this.editedItem = { id: 0, name: "", values: "" }
		},
		editItem(item, isEdit) 
		{
			this.editedItem = item
			this.jsonItems = JSON.parse(this.editedItem.values)
			this.addDialogVisible = true
		},
		async upsertItem()
		{
			if (this.editedItem.name.trim() == "") 
			{
				window.showAlert('res_Msgs_FillRequired', 'warning')
				return
			}

			if (this.jsonItems.length == 0) 
			{
				window.showAlert('you need to add at least 1 item to the values list', 'warning')
				return
			}

			if (this.editedItem.id == 0)
			{
				var customLookupObj = { id: 0, name: this.editedItem.name, values: JSON.stringify(this.jsonItems) }

				await axios.post(constants.baseApiUrl + "Lookups/AddCustomlookup", customLookupObj)
					.then((res) => this.cancelAddDialog())
					.catch((err) => console.error("Error creating item:", err));
			}
			else
			{
				var customLookupObj = { id: this.editedItem.id, name: this.editedItem.name, values: JSON.stringify(this.jsonItems) }

				await axios.post(constants.baseApiUrl + "Lookups/UpdateCustomlookup", customLookupObj)
					.then((res) => this.cancelAddDialog())
					.catch((err) => console.error("Error creating item:", err));
			}
		},
		cancelAddDialog() 
		{
			this.addDialogVisible = false
			this.editedItem.id = 0
			this.editedItem.name = ""
			this.editedItem.values = ""
			this.jsonItems = []
			this.fetchData()
		},
		addJsonItem() 
		{
			if (this.jsonItem.Id.trim() == "" || this.jsonItem.Name.trim() == "" || this.jsonItem.NameAr.trim() == "") 
			{
				window.showAlert('res_Msgs_FillRequired', 'warning')
			}
			else
			{
				const newItem = { Id: this.jsonItem.Id, Name: this.jsonItem.Name, NameAr: this.jsonItem.NameAr }
				this.jsonItems.push(newItem)

				this.jsonItem.Id = ""
				this.jsonItem.Name = ""
				this.jsonItem.NameAr = ""
			}
		},
		saveJsonItem() 
		{
			let updatedJsonItems = this.jsonItems.map(item => 
			{
				if (item.Id.toString() == this.jsonItem.Id.toString()) 
				{
					return { Id: this.jsonItem.Id, Name: this.jsonItem.Name, NameAr: this.jsonItem.NameAr }
				}

				return item;
			});

			this.jsonItems = updatedJsonItems

			this.jsonItem.Id = ""
			this.jsonItem.Name = ""
			this.jsonItem.NameAr = ""
			this.isEdit = false
		},
		editJsonItem(item) 
		{
			this.isEdit = true
			this.jsonItem.Id = item.Id
			this.jsonItem.Name = item.Name
			this.jsonItem.NameAr = item.NameAr
		},
		deleteJsonItem(item) 
		{
			const index = this.jsonItems.indexOf(item);
			if (index !== -1) 
			{
				this.jsonItems.splice(index, 1);
			}
		},
		openDeleteDialog(item) 
		{
            window.showInformation(this.$t('res_Label_Alert'), this.$t("res_Msgs_DeletConfirmation"),
                () => 
				{
					axios.get(constants.baseApiUrl + "Lookups/DeleteCustomlookup?id=" + item.id)
						.then((res) => this.fetchData())
						.catch((err) => console.log(err));
                },
                () => { })
		},
	},
	mounted() 
	{
		this.fetchData()
	},
};
</script>